var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1237 4.63345L17.8784 9.87869L18.5856 13.4142L22.1211 14.1213L27.3663 8.87609L27.3668 8.87588C28.0161 10.4084 28.1713 12.1052 27.811 13.7302C27.4507 15.3551 26.5928 16.8272 25.3566 17.9417C24.1205 19.0562 22.5676 19.7575 20.9142 19.9481C19.2607 20.1387 17.589 19.8091 16.1317 19.0051L16.1318 19.0048L9.12109 27.1213C8.55837 27.6834 7.79548 27.999 7.00012 27.9988C6.20477 27.9986 5.44206 27.6825 4.87966 27.1201C4.31726 26.5577 4.0012 25.795 4.00098 24.9997C4.00075 24.2043 4.31637 23.4414 4.87845 22.8787L12.9949 15.868L12.9947 15.8681C12.1907 14.4108 11.861 12.7391 12.0516 11.0856C12.2422 9.43219 12.9436 7.87931 14.0581 6.64315C15.1725 5.40698 16.6447 4.54904 18.2696 4.18874C19.8945 3.82844 21.5914 3.98371 23.1239 4.63294L23.1237 4.63345Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/Wrench.8d4690e30718f756c6d3bc0bb378069a.svg";
export { ForwardRef as ReactComponent };